import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

/**
 * Layout Component
 * Wrapper layout with Sidebar and Header
 * Provides consistent layout across all pages
 */
const Layout = ({ children, title = "Dashboard" }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content Area */}
      <div className="ml-64">
        {/* Header */}
        <Header title={title} />

        {/* Page Content */}
        <main className="p-8">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
